export default "__VITE_ASSET__19e26425__"